// restore focus after pressing Esc key
document.addEventListener('hide.bs.dropdown', function (e) {
  if (document.activeElement && document.activeElement.closest('.dropdown-menu')) {
    e.target.addEventListener('hidden.bs.dropdown', () => e.target.focus(), { once: true });
  }
});
